export enum OverviewType {
  SETTLEMENT_OVERVIEW = 'SETTLEMENT_OVERVIEW', POSITION_OVERVIEW = 'POSITION_OVERVIEW'
}
